/***
 * Created on 2024/1/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import ic_sys_attention_svg from '../../static/img/utils/ic_sys_attention.svg';
import {useTranslation} from "react-i18next";
import EmailChangedDialog from "./EmailChangedDialog";

function AttentionBar({organizations, doRefresh}) {
    const { t } = useTranslation();
    const [showChangeDialog, setShowChangeDialog] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const email_changed_org = [];
    organizations?.forEach(org => {
        let _users = org?.users?.filter(u => u?.email_changed) || [];
        if (_users?.length > 0) {
            email_changed_org.push({org: org, users:_users});
        }
    });

    return (
        <>
            {
                email_changed_org?.length > 0 &&
                <div className="attention-bar">
                    <div className="comp-attention--dropdown">
                        <div className="comp-attention comp-attention--medium">
                            <div className="attention__wrapper">
                                <div className="attention-ic">
                                    <img src={ic_sys_attention_svg} alt=""/>
                                </div>
                                <div className="attention-label">
                                    <span className="attention-label__inner-text" dangerouslySetInnerHTML={{
                                        __html: t('@<b>{{org_count}}</b> organization(s) has experienced email address updates related to QID. To avoid any impact on functionality, please confirm as soon as possible.@', {org_count: email_changed_org?.length})
                                    }}>
                                    </span>
                                </div>
                                <div className="attention-action">
                                    <svg className="comp-interactive-arrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                        <g fillRule="evenodd">
                                            <path className="interactive-arrow__tip" d="M0 0 l5 5 5 -5"></path>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className="attention__dropdown">
                                <div className="attention__dropdown__inner">
                                    <ul>
                                        {
                                            email_changed_org?.length > 0 &&
                                            email_changed_org.map((item, index)=>
                                                <li onClick={() => {setCurrentItem(item);setShowChangeDialog(true)}} key={index}>
                                                    <div className="tag tag-tiny"><span className="tag-label">{item.org.name}</span></div>
                                                    <div dangerouslySetInnerHTML={{
                                                        __html: t('@<b>{{user_count}}</b> email address has been updated.@', {user_count: item?.users?.length})
                                                    }}>
                                                    </div>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showChangeDialog && <EmailChangedDialog isOpenDialog={showChangeDialog} onClose={()=>setShowChangeDialog(false)} org={currentItem?.org} emailChangedUsers={currentItem?.users} />}
                </div>
            }
        </>
    );
}

export default AttentionBar;